var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273.826,
    height: 170,
    viewBox: "0 0 273.826 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptopcode",
    transform: "translate(546.914 -18864.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M555.505,503.968h-200.1a3.464,3.464,0,0,1-3.459-3.461V391.591a3.465,3.465,0,0,1,3.461-3.461H555.505a3.465,3.465,0,0,1,3.461,3.461V500.507A3.465,3.465,0,0,1,555.505,503.968ZM355.411,391.054a.537.537,0,0,0-.537.537V500.507a.536.536,0,0,0,.535.537h200.1a.537.537,0,0,0,.537-.537V391.591a.537.537,0,0,0-.537-.537Z",
    transform: "translate(-865.236 18487.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M521.351,469.723h-2.7c-56.094,0-224.4-.366-226.1-.37l-2.734-.006,1.085-121.418a15.746,15.746,0,0,1,15.733-15.709h199.79a15.751,15.751,0,0,1,15.733,15.733ZM295.3,463.929c21.705.047,166.252.353,220.654.363l.778-116.357a10.311,10.311,0,0,0-10.3-10.285H306.642a10.315,10.315,0,0,0-10.3,10.3Z",
    transform: "translate(-816.085 18532.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M904.47,630.1l24.808-11.266H930.9v5.47L912,632.642v.38l18.9,8.287v5.47h-1.625L904.47,635.511Z",
    transform: "translate(-1300.897 18305.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1068.505,583.3h5.008L1061.6,628.528h-5.146Z",
    transform: "translate(-1422.599 18333.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1157.67,641.3l18.9-8.287v-.38l-18.9-8.342v-5.47h1.625l24.808,11.266V635.5l-24.808,11.266h-1.625Z",
    transform: "translate(-1503.721 18305.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(-500.515 18893.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 9.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 19.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 28.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M29.061-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H29.061a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,29.061-5.532Z",
    transform: "translate(36.012 9.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M4.558-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H4.558A1.984,1.984,0,0,1,6.542-7.516,1.984,1.984,0,0,1,4.558-5.532Z",
    transform: "translate(79.041 9.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M6.442-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H6.442A1.984,1.984,0,0,1,8.426-7.516,1.984,1.984,0,0,1,6.442-5.532Z",
    transform: "translate(36.006 19.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    "data-name": "Line 11",
    d: "M21.375-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H21.375a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,21.375-5.532Z",
    transform: "translate(36.021 28.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_12",
    "data-name": "Line 12",
    d: "M23.447-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H23.447a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,23.447-5.532Z",
    transform: "translate(71.171 28.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_13",
    "data-name": "Line 13",
    d: "M11.037-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.037a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.037-5.532Z",
    transform: "translate(36.006 38.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_14",
    "data-name": "Line 14",
    d: "M16.133-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H16.133a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,16.133-5.532Z",
    transform: "translate(60.983 38.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_15",
    "data-name": "Line 15",
    d: "M2.716-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H2.716A1.984,1.984,0,0,1,4.7-7.516,1.984,1.984,0,0,1,2.716-5.532Z",
    transform: "translate(91.067 38.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_16",
    "data-name": "Line 16",
    d: "M1.759-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H1.759A1.984,1.984,0,0,1,3.744-7.516,1.984,1.984,0,0,1,1.759-5.532Z",
    transform: "translate(36.006 47.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_17",
    "data-name": "Line 17",
    d: "M12.833-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H12.833a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,12.833-5.532Z",
    transform: "translate(51.722 47.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    "data-name": "Line 18",
    d: "M6.9-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H6.9A1.984,1.984,0,0,1,8.886-7.516,1.984,1.984,0,0,1,6.9-5.532Z",
    transform: "translate(78.47 47.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    d: "M28.533-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H28.533a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,28.533-5.532Z",
    transform: "translate(36 57.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    d: "M8.207-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H8.207a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,8.207-5.532Z",
    transform: "translate(78.435 57.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    "data-name": "Line 21",
    d: "M15.279-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H15.279a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,15.279-5.532Z",
    transform: "translate(35.977 66.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_22",
    "data-name": "Line 22",
    d: "M7.513-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H7.513A1.984,1.984,0,0,1,9.5-7.516,1.984,1.984,0,0,1,7.513-5.532Z",
    transform: "translate(65.027 66.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_23",
    "data-name": "Line 23",
    d: "M-1.062-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5h6.454A1.984,1.984,0,0,1,.922-7.516,1.984,1.984,0,0,1-1.062-5.532Z",
    transform: "translate(86.456 66.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    "data-name": "Line 24",
    d: "M3.852-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H3.852A1.984,1.984,0,0,1,5.836-7.516,1.984,1.984,0,0,1,3.852-5.532Z",
    transform: "translate(36.006 76.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_25",
    "data-name": "Line 25",
    d: "M28.194-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5h35.71a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,28.194-5.532Z",
    transform: "translate(53.763 76.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_26",
    "data-name": "Line 26",
    d: "M-7.516-5.428A1.984,1.984,0,0,1-9.5-7.4a1.984,1.984,0,0,1,1.97-2L6.842-9.5a1.984,1.984,0,0,1,2,1.97,1.984,1.984,0,0,1-1.97,2l-14.372.1Z",
    transform: "translate(36.012 85.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_27",
    "data-name": "Line 27",
    d: "M36.047-5.428h0l-43.563-.1A1.984,1.984,0,0,1-9.5-7.521,1.984,1.984,0,0,1-7.511-9.5l43.563.1a1.984,1.984,0,0,1,1.979,1.989A1.984,1.984,0,0,1,36.047-5.428Z",
    transform: "translate(56.842 85.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_28",
    "data-name": "Line 28",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 38.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_29",
    "data-name": "Line 29",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 47.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_30",
    "data-name": "Line 30",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 57.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_31",
    "data-name": "Line 31",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 66.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_32",
    "data-name": "Line 32",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 76.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_33",
    "data-name": "Line 33",
    d: "M11.039-5.532H-7.516A1.984,1.984,0,0,1-9.5-7.516,1.984,1.984,0,0,1-7.516-9.5H11.039a1.984,1.984,0,0,1,1.984,1.984A1.984,1.984,0,0,1,11.039-5.532Z",
    transform: "translate(9.5 85.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(-546.914 18996.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M213.479,963.58H441.892l22.294,30.065.135.318a5.01,5.01,0,0,1,.021,4.019,4.559,4.559,0,0,1-4.334,2.309l-.31-.008L196.681,1001.7c-.114.008-.277.015-.473.015a5.008,5.008,0,0,1-4.695-2.492,5.373,5.373,0,0,1-.3-4.093l.136-.389Zm225.469,5.848H216.5l-18.765,26.42,259.771-1.395Z",
    transform: "translate(-190.939 -963.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M716.05,1099.924s.741-5.464,2.241-6.625c1.9-1.474,23.657-1.124,23.657-1.124s25.451-.322,27.554.785c1.55.817,2.506,6.662,2.506,6.662Z",
    transform: "translate(-606.377 -1065.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131_-_Outline",
    "data-name": "Path 131 - Outline",
    d: "M711.467,1097.6l.129-.953c.131-.969.873-5.869,2.557-7.173.471-.365,1.723-1.335,18.778-1.335,3.138,0,5.4.037,5.4.037-.024,0,3.42-.043,7.878-.043,18.295,0,19.571.672,20.052.925,1.78.938,2.7,5.8,2.942,7.267l.158.965Zm21.464-7.79c-15.485,0-17.511.824-17.76.99-.723.56-1.407,3.073-1.769,5.119l53.98-.29c-.476-2.361-1.274-4.766-1.894-5.093-.353-.171-2.795-.732-19.273-.732-4.445,0-7.879.043-7.881.043C738.306,1089.846,736.051,1089.81,732.931,1089.81Z",
    transform: "translate(-602.752 -1062.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_34",
    "data-name": "Line 34",
    d: "M202.5-4.076H-5.538A1.462,1.462,0,0,1-7-5.538,1.462,1.462,0,0,1-5.538-7H202.5a1.462,1.462,0,0,1,1.462,1.462A1.462,1.462,0,0,1,202.5-4.076Z",
    transform: "translate(38.433 17.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35",
    "data-name": "Line 35",
    d: "M214.258-4.076H-5.538A1.462,1.462,0,0,1-7-5.538,1.462,1.462,0,0,1-5.538-7h219.8a1.462,1.462,0,0,1,1.462,1.462A1.462,1.462,0,0,1,214.258-4.076Z",
    transform: "translate(32.025 24.609)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopcode);
export default __webpack_public_path__ + "static/media/laptopcode.08e481232af5ccc65fdb726ddac94add.svg";
export { ForwardRef as ReactComponent };